import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Pagination from '@material-ui/lab/Pagination';

const useStyles = makeStyles({
  ul: {
    justifyContent: 'center'
  },
  root: {
    '& button': {
      width: '32px',
    },
    '& .MuiPaginationItem-page.Mui-selected': {
      backgroundColor: '#00A15D',
      color: 'white'
    },
    '& .MuiPaginationItem-page:hover': {
      backgroundColor: '#00A15D52',
    }
  }
});

export default function BasicPagination({ count, page = 1, defaultPage, onChange }) {
  const classes = useStyles();
  return (
    <div>
      <Pagination count={count} page={page} defaultPage={defaultPage} onChange={onChange} classes={{ ul: classes.ul, root: classes.root }} />
    </div>
  );
}
